var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1228 6.88481C6.1228 4.19119 8.30645 2.00754 11.0001 2.00754C13.6937 2.00754 15.8773 4.19119 15.8773 6.88481C15.8773 9.57844 13.6937 11.7621 11.0001 11.7621C8.30645 11.7621 6.1228 9.57844 6.1228 6.88481Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7287 14.202C18.5497 14.9233 19.0171 15.9655 19.0171 17.0584V18.4683C19.0171 19.31 18.3347 19.9924 17.4929 19.9924H4.50718C3.66543 19.9924 2.98303 19.31 2.98303 18.4683V17.0584C2.98303 13.2372 7.9801 11.762 11 11.762",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgUser;